// @ts-nocheck
import { UserType } from '@src/interfaces/type';
import PermissionsModel from './PermissionsModel';

class UserModel {
	public id?: Number;
	public username?: string;
	public userType: UserType;

	constructor(data) {
		if (!data) return;

		// this.id = data.id;
		// this.username = data.username;
		// this.firstName = data.first_name;
		// this.lastName = data.last_name;
		// this.groups = data.groups;
		// this.permissions = new PermissionsModel(data.permissions);
		// this.profile = data.profile;
		// this.role = data?.profile?.role;
		// this.isAdmin = this.role === 'admin';

		//new format
		this.id = data?._id;
		this.username = data?.email;
		this.firstName = data?.first_name;
		this.lastName = data?.last_name;
		this.profile = data?.image;
		this.type = data?.type;
		this.userId = data?.userId;
		this.companyName = data?.companyName;
		this.phone = data?.phone;
		this.email = data?.email;
		this.organization = data?.organization;
		this.ocUser = data?.oc_user;
		this.userType = data?.oc_user?.type;
	}

	prepareUserLabel = () => {
		let label = '';
		if (this.firstName) {
			label = this.firstName;
		}

		if (this.lastName) {
			if (label) {
				label += ' ';
			}

			label += this.lastName;
		}

		if (label) {
			label += ` (${this.username})`;
		} else {
			label = this.username;
		}

		return label;
	};

	isInGroup(groupId) {
		let inGroup = false;

		this.groups?.forEach((groupItem) => {
			if (groupItem?.id === groupId) {
				inGroup = true;
			}
		});

		return inGroup;
	}

	isBot() {
		if (this.groups) {
			for (let i = 0; i < this.groups.length; i++) {
				const group = this.groups[i];
				if (group.name === 'App integration') {
					return true;
				}
			}
		}

		return false;
	}
}

export default UserModel;
